// import 'babel-polyfill';
// import 'font-awesome-loader';
// import { } from '@fortawesome/fontawesome-free';

import React from 'react';
import { createRoot } from 'react-dom/client';

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { fab } from '@fortawesome/free-brands-svg-icons';
// import { far } from '@fortawesome/free-regular-svg-icons';
// import { fas } from '@fortawesome/free-solid-svg-icons';
// import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons'

// library.add(fab, far, fas)

import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { io } from 'socket.io-client';
import translations from './translations';
import 'whatwg-fetch';

import './global.scss';
import '../../node_modules/@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import Reducers from './reducers';

import Root from './Root';


const store = createStore(Reducers, compose(applyMiddleware(thunk), window.devToolsExtension ? window.devToolsExtension() : f => f));

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale('en'));


window.io = io;

global.socket = null;
global.store = store;

const root = createRoot(document.getElementById('root'));
root.render(
  <Root store={store} />
);

if (import.meta.hot) {
  import.meta.hot.accept();
}
